/** The live-session fields the Status screen reads from nuance.controller-health/1. */
export interface ControllerHealthLive {
  state: 'connecting' | 'active' | 'ended' | 'failed';
  framesApplied: number;
  worstFrameLatenessUs?: number;
  internalHeapMinBytes: number;
}

function object(value: unknown): Record<string, unknown> | undefined {
  return value !== null && typeof value === 'object' && !Array.isArray(value)
    ? value as Record<string, unknown> : undefined;
}

function count(value: unknown): value is number {
  return Number.isSafeInteger(value) && Number(value) >= 0;
}

/** A missing leaf or an unrecognised document contributes no device detail. */
export function controllerHealthLive(value: unknown, deviceId: string): ControllerHealthLive | undefined {
  const health = object(value);
  if (health?.schema !== 'nuance.controller-health/1') return undefined;
  if (object(health.identity)?.deviceId !== deviceId) return undefined;
  const live = object(object(object(health.ext)?.sculpture)?.live);
  if (!live || !['connecting', 'active', 'ended', 'failed'].includes(String(live.state))) return undefined;
  if (!count(live.framesApplied) || !count(live.internalHeapMinBytes)) return undefined;
  if (live.worstFrameLatenessUs !== undefined && !count(live.worstFrameLatenessUs)) return undefined;
  return {
    state: live.state as ControllerHealthLive['state'],
    framesApplied: live.framesApplied,
    internalHeapMinBytes: live.internalHeapMinBytes,
    ...(live.worstFrameLatenessUs !== undefined ? { worstFrameLatenessUs: live.worstFrameLatenessUs } : {}),
  };
}
